import { SET_SUPPORT } from '../actions/types/index';

export default (state = null, action) => {
  switch (action.type) {
    case SET_SUPPORT:
      return action.payload;
    default:
      return state;
  }
};
